/**
 * Admin host for the current Torneos build (dev / staging / prod).
 */
export function revaAdminBaseUrl() {
  const env = (process.env.REACT_APP_ENV || "").toLowerCase();
  const baseDomain = (process.env.REACT_APP_BASE_DOMAIN || "").replace(/\/$/, "");

  if (baseDomain) {
    return baseDomain;
  }

  if (env === "staging") {
    return "https://admin.staging.reva.kynox.com.py";
  }

  if (env === "production" || env === "prod") {
    return "https://admin.reva.la";
  }

  return "https://admin.dev.reva.kynox.com.py";
}

export function revaAdminBillingSummaryUrl() {
  return `${revaAdminBaseUrl()}/u/account/billing/summary`;
}

export function revaAdminSetAccountBillingUrl(accountId) {
  return `${revaAdminBaseUrl()}/u/account/set-account/${accountId}?next=billing`;
}

export function revaAdminSetAccountCobrosUrl(accountId) {
  return `${revaAdminBaseUrl()}/u/account/set-account/${accountId}?next=edit-payment-methods`;
}
